import { useRef, useEffect } from "react";
import useRegistrationContext from "../../../../hooks/useRegistrationContext";
import toast, { Toaster } from "react-hot-toast";


const ProfessionOccupation = () => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const inputRef = useRef();

	useEffect(() => { 
		inputRef.current.focus();
	},[])

	
	const {
		data,
		handleChange,
		regularData,
		} = useRegistrationContext();

	
	const content = (
		<>
			<fieldset className="col-sm-12">
				<fieldset className="col-sm-6">
					<div className="form-group row">
						<label
							htmlFor="profession"
							className="col-sm-4 label-text"
						>
							Profession<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<input
								ref={inputRef}
								type="text"
								id="profession"
								autoComplete="off"
								onChange={handleChange}
								required
								style={{
									textTransform: "uppercase",
								}}
								value={data.professionProfession}
								name="professionProfession"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label
							htmlFor="occupation"
							className="col-sm-4 label-text"
						>
							Occupation<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<input
							
								type="text"
								id="occupation"
								autoComplete="off"
								onChange={handleChange}
								required
								style={{
									textTransform: "uppercase",
								}}
								value={data.professionOccupation}
								name="professionOccupation"
								className="form-control"
							/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="employment_type" className="col-sm-4 label-text">
							Employment Type<span>&nbsp;&nbsp;*</span>
						</label>
						{regularData.employmentType.map((item) => (
						<div className="col-sm-4" key={item.id}>
							<label htmlFor={`employment_type${item.id}`}>
								<input
									type="checkbox"
									id={`employment_type${item.id}`}
									name="professionEmploymentType"
									checked={data.professionEmploymentType === item.value}
									value={item.value}
									onChange={handleChange}
								/>
							</label>
							<span className="checkbox-label">{item.label}</span>
						</div>
					))}
				</div>
					
					<div className="form-group row">
						<label
							htmlFor="Current_employment"
							className="col-sm-4 label-text"
						>
							Current Employment<span>&nbsp;&nbsp;*</span>
						</label>
						<div className="col-sm-8">
							<input
								type="text"
								id="Current_employment"
								autoComplete="off"
								onChange={handleChange}
								style={{
									textTransform: "uppercase",
								}}
								value={data.professionCurrentEmployment}
								name="professionCurrentEmployment"
								className="form-control"
							/>
						</div>
					</div>
				</fieldset>
			</fieldset>
		</>
	);
	<Toaster toastOptions={{ position: "top-center" }} />;
	return content;
};
export default ProfessionOccupation;
